<div class="sipPitchOtdWrap">
  <div class="content">
    <div class="logo"><img ngSrc="assets/images/hunger.png" width="80" height="98" alt="hunger"></div>
    <div class="actSection">
      <div class="checkBox" (click)="onCheck()">
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="18" viewBox="0 0 17 18" fill="none">
          <g clip-path="url(#clip0_5583_11015)">
            <rect *ngIf="isChecked" y="0.299805" width="20" height="20" fill="#288B91"/>
            <path *ngIf="isChecked" d="M5 8.7998L7.66667 11.2998L13 6.2998" stroke="#FCFCFC" stroke-width="2"/>
            <rect *ngIf="!isChecked" x="0.5" y="0.799805" width="16" height="16" rx="6" stroke="#288B91" stroke-width="1" fill="none"/>
          </g>
          <defs><clipPath id="clip0_5583_11015"><rect y="0.299805" width="17" height="17" rx="6" fill="white"/></clipPath></defs>
        </svg>
      </div>
      <div class="text">
        <div class="title">Make a lasting impact.</div>
        <div class="sub-title">Choose a monthly contribution plan with just <strong><app-currency [currency]="currency" />{{displayAmt}}/ month.</strong></div>
      </div>
    </div>
  </div>
</div>